import { render, staticRenderFns } from "./BtnCancelarPlano.vue?vue&type=template&id=81d2c378&"
import script from "./BtnCancelarPlano.vue?vue&type=script&lang=js&"
export * from "./BtnCancelarPlano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports